<template>
  <div class="page-content" id="newLinkList">
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>监控中心</el-breadcrumb-item>
      <el-breadcrumb-item>监控链接</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <el-form class="search-form" style="margin-left: -30px;">
        <el-form-item label="商品标题" :label-width="formLabelWidth">
          <el-input placeholder="请输入" v-model.trim="itemTitle" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="店铺名称" :label-width="formLabelWidth">
          <el-input placeholder="请输入" v-model.trim="shopname" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="平台" :label-width="formLabelWidth">
          <el-select v-model="platform" filterable clearable placeholder="请选择" size="small">
            <el-option
              v-for="item in platformList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接状态" :label-width="formLabelWidth">
          <el-select clearable placeholder="请选择" size="small" v-model="linkStatus">
            <el-option value="0" label="上架"></el-option>
            <el-option value="2" label="下架"></el-option>
            <el-option value="1" label="失效"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通知人" :label-width="formLabelWidth">
          <el-select v-model="noticeuserid" filterable clearable placeholder="请选择" size="small">
            <el-option
              v-for="item in noticePeoData"
              :key="item.openid"
              :label="item.nickname"
              :value="item.openid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-top: -4px;">
          <el-button size="small" class="search-btn" @click="theQuery()">查询</el-button>
        </el-form-item>
      </el-form>
    </section>

    <div class="page">
      <div class="downBtn" v-if="type.editStatus">
        <el-button size="small" type="primary" @click="newAdd()" icon="el-icon-plus">新增</el-button>
        <el-button size="small" @click="onOpenDeleteDia(2)">批量删除</el-button>
        <el-button size="small" @click="useUpdateStatus(1)">批量启用</el-button>
        <el-button size="small" @click="useUpdateStatus(0)">批量停用</el-button>
        <el-button size="small" @click="notifyPeo">批量设置通知人</el-button>
        <el-button size="small" @click="pushDialog = true" :disabled="pushDis">推送方式设置</el-button>
        <el-button size="small" @click="triggerPeo">管理通知人</el-button>
        <el-button size="small" @click="downDataClick">下载数据</el-button>
      </div>
      <div class="downBtn" v-else>
        <el-button size="small" @click="downDataClick">下载数据</el-button>
      </div>
      <div class="prompt">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
        共<span class="promptFont">{{totalNum}}</span>项,已选择<span class="promptFont">{{openNumber}}</span>项
        <span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
        <span class="promptFont">/</span>
        <span class="promptFont2" @click="toggleSelection()">取消勾选</span>
      </div>
      <el-table
        @selection-change="handleSelectionChange"
        :data="tableData"
        ref="multipleTable"
        v-loading="dataLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        @row-click="tableClick"
        style="width: 100%"
        >
        <el-table-column type="selection" min-width="3%">
        </el-table-column>

        <el-table-column label="序号" type="index" min-width="5%">
        </el-table-column>

        <el-table-column  min-width="5%">
          <template slot-scope="scope">
            <div class="low-price" v-show="scope.row.islowprice === '1'">低</div>
            <div class="newSku" v-show="scope.row.newskustatus == '1'">新SKU</div>
          </template>
        </el-table-column>

        <el-table-column label="监控信息" min-width="32%">
          <template slot-scope="scope">
            <div class="shopMain">
							<img :src="scope.row.picurl" alt/>
							<div class="content">
									{{scope.row.itemtitle}}
                <el-link class="align_left" :underline="false" :href="scope.row.itemlink" type="primary" target="_blank">
									{{scope.row.itemlink}}
								</el-link>
							</div>
						</div>
          </template>
        </el-table-column>

        <el-table-column label="店铺信息" min-width="18%">
          <template slot-scope="scope">
            <div v-if="scope.row.shopname" class="align_left ellipsis">{{scope.row.shopname}}</div>
            <div v-else class="align_left ellipsis">/</div>
            <div
              v-if="scope.row.wangwang && scope.row.platform !='JD' && scope.row.platform !='SN' && scope.row.platform !='DD'"
              class="align_left ellipsis"
            >{{scope.row.wangwang}}</div>
            <div class="tall_icon">
              <img
                :src='require("@/assets/img/platform/pla_"+scope.row.platform+".png")'
                alt
                class="edit_icon"
                style="float: left;"
              />
              <span style="margin-top: 8px;" class="shoptype green" v-show="scope.row.authorize">{{scope.row.authorize}}</span>
              <ShopType style="float: left;" :shoptype="parseInt(scope.row.shoptype)" v-if="scope.row.shoptype"/>
            </div>
					</template>
        </el-table-column>

        <el-table-column prop="status" label="状态" min-width="8%">
          <template slot-scope="scope">
            <span v-show="scope.row.status == '0'" style="color: #52c41a;">上架</span>
            <span v-show="scope.row.status == '2'" style="color: #e90e24;">下架</span>
          </template>
        </el-table-column>

        <el-table-column label="通知人" min-width="18%">
          <template slot-scope="scope">
            <span v-if="scope.row.noticeList.length >0">
              <span v-for="item in scope.row.noticeList">
                <!-- {{item.nickname}}
                {{item.remark}} -->
                <span v-if="item.remark">
                  {{ item.remark }}
                </span>
                <span v-if="!item.remark">
                  {{ item.nickname }}
                </span>
              </span>

            </span>
          </template>
        </el-table-column>

        <el-table-column min-width="12%" label="计划状态" v-if="type.editStatus">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.monitorstatus === 0 ? true : false"
              @change="(val) => onStatusChange(val, scope.row.id)"
              active-color="#408ae7"
              inactive-color="#d9d9d9"
              active-text="开"
              inactive-text="关"
              @click.stop.native>
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" min-width="12%" v-if="type.editStatus">
          <template slot-scope="scope">
            <div style="float: left;">
              <div class="g-inline-block" style="color: #108cee;cursor: pointer;float: left;" @click.stop="editor(scope.row)">
                <i class="el-icon-edit-outline"></i>
                <span class="g-inline-block">编辑</span>
              </div>
              <div class="g-margin-left" style="color: #108cee;cursor: pointer;float: left;margin-left: 10px;" @click.stop="onOpenDeleteDia(1,scope.row.id)">
                <i class="el-icon-delete"></i>
                <span class="g-inline-block">删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="this.tableData.length >= 1">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
      <!-- 删除 -->
      <el-dialog
        title="提示"
        :visible.sync="deleteShow"
        width="360px" style="margin-top: 10%;" id="dialog">
          <div style="display: flex;width: 100%;justify-content:center;">
            <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
            <div>
              <div style="font-size: 16px;">
                你确认要删除<span>{{delType}}</span>监控吗？
              </div>
              <div style="font-size: 14px;">删除后
                <span style="color: #e90e24;font-size: 14px;">
                  监控信息将会被彻底删除
                </span>
              </div>
            </div>
          </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="deleteClassification" size="small" :loading="ficationLoading">确 定</el-button>
          <el-button @click="delCancel" size="small" type="TheCustom">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 下载数据 -->
      <el-dialog
  			title="下载数据"
  			:visible.sync="downDataDialog"
  			:close-on-click-modal="false"
  			width="640px"
        id="dialog">
  			<el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
          <div class="seaerch-wrapper">
  					<el-form label-width="100px">
  						<el-form-item label="数据时间" :required="true">
                <el-radio-group v-model="downData.dataTime" style="width: 440px;">
                  <el-radio label="1">最近一次</el-radio>
                  <el-radio label="2">今日监控数据</el-radio>
                  <el-radio label="3">自定义时间</el-radio>
                </el-radio-group>
  						</el-form-item>
  						<el-form-item label="时间范围" v-if="downData.dataTime == '3'">
                <el-date-picker
                  v-model="downData.searchformDate"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  range-separator="~"
                  :picker-options="pickerOptions"
                  size="small"
                  clearable
                   style="width: 440px;">
                </el-date-picker>
  						</el-form-item>
  					</el-form>
  				</div>
  			</el-row>
  			<span slot="footer">
  				<el-button size="small" type="primary" @click="download" :loading="downloadLoading">确 定</el-button>
  				<el-button size="small" type="TheCustom" @click="downDataDialog = false">取 消</el-button>
  			</span>
  		</el-dialog>
      <!-- 批量设置通知人 -->
      <el-dialog
  			title="批量设置通知人"
  			:visible.sync="notifyDialog"
  			:close-on-click-modal="false"
  			width="640px"
        id="dialog">
  			<el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
          <div class="seaerch-wrapper">
  					<el-form label-width="100px">
  						<el-form-item label="通知人">
                <el-select v-model="notify" size="small" clearable multiple placeholder="请选择" style="width: 440px;">
                  <el-option
                    v-for="item in noticePeoData"
                    :key="item.openid"
                    :label="item.nickname"
                    :value="item.openid">
                  </el-option>
                </el-select>
  						</el-form-item>
  					</el-form>
  				</div>
  			</el-row>
  			<span slot="footer">
  				<el-button size="small" type="primary" @click="notifyClick" :loading="notifyLoading">确 定</el-button>
  				<el-button size="small" type="TheCustom" @click="notifyDialog = false">取 消</el-button>
  			</span>
  		</el-dialog>
      <!-- 推送方式设置 -->
      <el-dialog
  			title="推送方式设置"
  			:visible.sync="pushDialog"
  			:close-on-click-modal="false"
  			width="640px"
        id="dialog">
  			<el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
          <div class="seaerch-wrapper">
  					<el-form>
              <el-form-item :required="true">
                <el-radio v-model="noticeway" label="0">微信推送</el-radio>
                <el-radio v-model="noticeway" label="1">邮箱推送</el-radio>
  						</el-form-item>
  						<el-form-item :required="true">
                <el-radio v-model="pushmode" label="1">每小时监控完成推送，每小时推送一次，一天推送24次。</el-radio>
                <el-radio v-model="pushmode" label="2">
                  特定时间点推送，每日
                  <el-time-select
                    v-model="noticeType"
                    :picker-options="{
                      start: '00:00',
                      step: '01:00',
                      end: '23:00'
                    }"
                    placeholder="选择时间"
                    size="small"
                    style="width: 120px;">
                  </el-time-select>
                  监控完成后，推送最近24小时的监控数据
                 </el-radio>
  						</el-form-item>
  					</el-form>
  				</div>
  			</el-row>
  			<span slot="footer">
  				<el-button size="small" type="primary" @click="pushClick" :loading="pushLoading">确 定</el-button>
  				<el-button size="small" type="TheCustom" @click="pushDialog = false">取 消</el-button>
  			</span>
  		</el-dialog>
      <!-- 管理通知人 -->
      <administrativeNotifier ref="childDialog" />

      <el-dialog
  			title="编辑"
  			:visible.sync="shopEdit"
  			:close-on-click-modal="false"
  			width="960px"
        id="dialog">
  			<el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
          <div class="seaerch-wrapper" v-loading="diaLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading">
            <el-table :data="skuTableData">

              <el-table-column label="序号" type="index" width="50">
              </el-table-column>

              <el-table-column label="商品信息/SKU信息" prop="skuTitle">
              </el-table-column>

              <el-table-column prop="status" label="限价">
                <template slot-scope="scope">
                  <el-input placeholder="请输入" :disabled="scope.row.deleteFlag == 1" v-model="priceInput[scope.$index]" size="small" clearable type="number"></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.deleteFlag == 0">
                    <span style="color: #108CEE;">
                      ●
                    </span>
                    监控中
                  </div>
                  <div v-if="scope.row.deleteFlag == 1">
                    <span style="color: #BFBFBF;">
                      ●
                    </span>
                    未监控
                  </div>
                  <div v-if="scope.row.deleteFlag == 3">
                    <span style="color: #FAAD14;">
                      ●
                    </span>
                    新增SKU
                  </div>
                </template>
              </el-table-column>

              <el-table-column width="210" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" v-if="scope.row.deleteFlag == 1" @click="deleteNewMonitorSku(scope.row.id,scope.$index,0)">监控</el-button>
                  <el-button type="text" v-if="scope.row.deleteFlag == 0" @click="deleteNewMonitorSku(scope.row.id,scope.$index,1)">取消监控</el-button>
                </template>
              </el-table-column>
            </el-table>
  				</div>
  			</el-row>
  			<span slot="footer">
  				<el-button size="small" type="primary" @click="priceStandard" :loading="priceStandardLoading">确 定</el-button>
  				<el-button size="small" type="TheCustom" @click="shopEdit = false">取 消</el-button>
  			</span>
  		</el-dialog>
      <!-- 批量启用、停用 -->
      <el-dialog title="提示" :visible.sync="useShow" width="360px" style="margin-top: 10%;" id="dialog">
          <div style="display: flex;width: 100%;justify-content:center;">
              <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
             <div>
                 <div style="font-size: 16px;">你确认要{{useData}}{{openNumber}}监控吗？</div>
                 <div style="font-size: 14px;">{{useData}}后
                 <span style="color: #e90e24;font-size: 14px;" v-if="useData == '启用'">监控计划将会正常被执行</span>
                 <span style="color: #e90e24;font-size: 14px;" v-if="useData != '启用'">监控计划将不会被执行</span>
              </div>
             </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="useSure" size="small">确 定</el-button>
            <el-button @click="useShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
          </span>
      </el-dialog>
      <!-- 批量启用、停用  -->
    </div>
  </div>
</div>

</template>

<script>
import pagination from "../../../../components/dataTable/pagination";
import administrativeNotifier from "../administrativeNotifier";
import ShopType from "@/components/shopType";
  export default {
    data() {
      return {
        diaLoading: false,
        pushDis: true,
        smallDelLoading: false,
        priceStandardLoading: false,
        priceInput: [],
        skuTableData: [],
        noticeType: '',
        itemTitle: '',
        linkStatus: '',
        monOptions: [],
        shopEdit: false,
        shopname: '',
        noticeuserid: '',
        noticePeoData: [],
        pushDialog: false,
        pushLoading: false,
        pushmode: '2',
        noticeway: '0',
        notifyDialog: false,
        notifyLoading: false,
        notify: [],
        downDataDialog: false,
        downloadLoading: false,
        downData: {
          dataTime: '1',
          searchformDate: [],
        },
        delType: '',
        checkAll: '',
        ficationLoading: false,
        deleteShow: false,
        dataLoading: false,
        pageNo: 1,
        currentPage: 1,
        pageSize: 10,
        tableData: [],
        selectRows: [],
        delIds: [],
        time: [],
        platformList: [
  				{ value: 'TB', label: '淘宝' },
  				{ value: 'TM', label: '天猫' },
  				{ value: 'JD', label: '京东' },
          { value: 'SN', label: '苏宁' },
  				{ value: '1688', label: '1688' },
          { value: 'DD', label: '当当' },
  			],
        pickerOptions: {
  				shortcuts: [{
            text: '今日',
            onClick:(picker) => {
  						this.getRecentDate(picker,1);
  					}
          },{
            text: '近7日',
            onClick:(picker) => {
  						this.getRecentDate(picker,7);
  					}
          }, {
  					text: '近15日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,15);
  					}
  				}, {
  					text: '近30日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,30);
  					}
  				}, {
  					text: '近90日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,90);
  					}
  				}, {
  					text: '近365日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,365);
  					}
  				}]
  			},
        totalNum: 100,
        formLabelWidth: '100px',
        openNumber: 0,
        platform: '',
        planname: '',
        limitMonitorTimeNum: 1,

        user_name: '',
        priceIds: [],
        useStatus: '',
        useData: '启用',
        useShow: false,
        newSkuId: '',
        singlelinkNumber: '',
        objNumber: '',
        userid: '',
        type: {},
      }
    },
    mounted() {
      this.type = JSON.parse(window.localStorage.userData)
      fetch({
  			url: 'hcm/cus/selectbmcSetting'
  		}).then(res => {
  			if(res.status === '10000') {
  				this.limitMonitorTimeNum = res.data.productmonitorFrequency === 1 ? 2 : 1;
          this.singlelinkNumber = res.data.singlelinkNumber
          this.userid = res.data.bmcid
  			}
  		})
      this.theQuery()
      this.getWecharList()
    },
    methods: {
      // 确认
      useSure() {
        let params = {
          monitorstatus: this.useStatus,
          ids: this.delIds
        }
        if (this.platform) {
          params.platform = this.platform
        }
        if (this.shopname) {
          params.shopName = this.shopname
        }
        if (this.noticeuserid) {
          params.openid = this.noticeuserid
        }
        if (this.linkStatus) {
          params.linkStatus = this.linkStatus
        }
        if (this.itemTitle) {
          params.itemTitle = this.itemTitle
        }
        fetch({
          url: "hcm/monitorLink/openMonitorItemList",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.useShow = false
            this.theQuery();
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {

        })
      },
      // 批量启用
      useUpdateStatus(e) {
        if (e == 1) {
          this.useData = '启用'
          this.useStatus = 0
        } else {
          this.useData = '停用'
          this.useStatus = 1
        }
        if (this.checkAll == 2) {
          this.openNumber = '勾选的全部'
        } else {
          this.openNumber = '勾选的' + this.selectRows.length + '项'
        }
        let arrIds = []
        for (let i in this.selectRows) {
          arrIds.push(this.selectRows[i].id)
        }
        this.delIds = arrIds.join(',')
        if (this.delIds == '') {
          this.$message({
            message: '没有选中项',
            type: 'warning'
          });
          return
        }
        this.useShow = true
      },
      // 监控状态
      onStatusChange(val, id) {
        if (val == 1) {
          if (this.objNumber < this.singlelinkNumber) {
            this.useData = '启用'
            this.useStatus = 0
          } else {
            this.$message({
              message: '开启数量超出上限,请重新选择!',
              type: 'warning'
            });
            return
          }

        } else {
          this.useData = '停用'
          this.useStatus = 1
        }
        this.useShow = true
        this.openNumber = '该'
        this.delIds = id
  		},
      updateNewskustatus() {
        let params = {
          id: this.newSkuId
        }
        fetch({
          url: "hcm/monitorLink/updateNewskustatus",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {

        })
      },
      // 编辑限价
      priceStandard() {
        if (this.skuTableData.length != 0) {
          for (let a in this.skuTableData) {
            if (this.skuTableData[a].deleteFlag == 3 && this.priceInput[a] != '0.0') {
              this.updateNewskustatus()
            }
          }
        }
        this.priceStandardLoading = true
        let params={
          ids: this.priceIds.join(','),
          prices: this.priceInput.join(','),
        }
        fetch({
          url: "hcm/monitorLink/priceStandard",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.priceStandardLoading = false
            this.shopEdit = false
            this.theQuery()
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 监控操作
      deleteNewMonitorSku(id,index,type) {
        let params={
          skuid: id,
          type: type
        }
        fetch({
          url: "hcm/monitorLink/deleteNewMonitorSku",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            if (type == '1') {
              this.skuTableData[index].deleteFlag = '1'
            } else {
              this.skuTableData[index].deleteFlag = '0'
            }
            // this.theQuery()
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 下载数据
      downDataClick() {
        let params={
          pageNo: 1,
          pageSize: 10000,
        }
        fetch({
          url: "hcm/hcmShopMonitor/getShopMonitorPage",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            console.log(data)
            this.monOptions = data.content
            this.downData.dataTime = '1'
            this.downDataDialog = true
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 新增
      newAdd() {
        this.$router.push({
          name:'monitoringLink',
          query: {
            totalNum: this.totalNum,
          }
        })
      },
      // table点击
      tableClick(row) {
        console.log(row)
        this.$router.push({
          name:'linkDetails',
          query: {
            itemid:row.itemid,
            platform:row.platform,
            noticeusername:row.noticeList[0]?row.noticeList[0].remark:'',
            monitoringType:row.monitoringType,
            itemtitle:row.itemtitle,
            shopname:row.shopname,
            link:row.itemlink,
          }
        })
      },
      // 编辑
      editor(data) {
        console.log(data)
        this.newSkuId = data.id
        this.shopEdit = true
        this.getMonitorItemSKuList(data.itemid)
      },
      getMonitorItemSKuList(id) {
        this.diaLoading = true
        let params={
          itemid: id,
        }
        fetch({
          url: "hcm/monitorLink/getMonitorItemSKuList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            console.log(res)
            this.priceInput= []
            this.priceIds = []
            this.skuTableData = res.data
            if (this.skuTableData.length > 0) {
              for (let a in this.skuTableData) {
                this.priceInput.push(this.skuTableData[a].checkPrice)
                this.priceIds.push(this.skuTableData[a].id)
              }
            }
            this.diaLoading = false
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
            this.diaLoading = false
          }
        })
      },
      // 管理通知人
      triggerPeo() {
        this.$refs.childDialog.theTrigger(this.userid);

      },
      // 时间范围
      getRecentDate(picker,n){
  			const end = new Date();
  			const start = new Date();
  			start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
  			if(picker){
  				picker.$emit('pick', [start, end]);
        }
        if (n === 1) {
          this.downData.searchformDate[0] = end;
          this.downData.searchformDate[1] = end;
        } else {
          this.downData.searchformDate[0] = start;
          this.downData.searchformDate[1] = end;
        }
  		},
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.theQuery()
      },
      // 翻页
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.theQuery()
      },
      // 数据源
      theQuery() {
        this.dataLoading = true
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
        if (this.platform) {
          params.platform = this.platform
        }
        if (this.shopname) {
          params.shopName = this.shopname
        }
        if (this.noticeuserid) {
          params.openid = this.noticeuserid
        }
        if (this.linkStatus) {
          params.linkStatus = this.linkStatus
        }
        if (this.itemTitle) {
          params.itemTitle = this.itemTitle
        }
        fetch({
          url: "hcm/monitorLink/getMonitorItemList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.dataLoading = false
            this.tableData = data.content
            this.totalNum = data.totalElements
            this.objNumber = Number(data.obj)
            console.log(this.objNumber)
            if (this.tableData.length > 0) {
              this.pushDis = false
              // 2021.1.25 zzj 字符串
              if (this.tableData[0].noticeType == 'perhour') {
                this.pushmode = '1'
                this.noticeType = ''
              } else {
                this.pushmode = '2'
                this.noticeType = this.tableData[0].noticeType
              }
            } else {
              this.pushDis = true
            }
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 通知人微信数据
      getWecharList() {
        fetch({
          url: "hcm/hcmNewMonitorProduct/getWecharList",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.noticePeoData = res.data
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 序号勾选
      handleSelectionChange(val) {
        this.openNumber = val.length;
        this.selectRows = val;
      },
      // 勾选
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleAllSelection(row);
            this.openNumber = this.totalNum
            this.checkAll = 2
          });
        } else {
          this.$refs.multipleTable.clearSelection();
          this.checkAll = 1
          this.openNumber = 0
        }
      },
      // 删除
      onOpenDeleteDia(e,ids) {
        this.delIds = ''
        if (ids && e == 1) {
          this.delType = '该'
          this.delIds = ids
        } else if (this.checkAll == 2 && e == 2) {
          this.delType = '全部'
          this.delIds = "checkAll"
        } else {
          this.delType = this.openNumber + '条'
          let arrIds = []
          for (let i in this.selectRows) {
            arrIds.push(this.selectRows[i].id)
          }
          this.delIds = arrIds.join(',')
        }
        if (this.delIds == '') {
          this.$message({
            message: '没有选中项',
            type: 'warning'
          });
          return
        }
        this.deleteShow = true
      },
      // 取消删除
      delCancel() {
        this.deleteShow = false
        this.delType = ''
        this.checkAll = ''
        this.delIds = ''
      },
      // 确认删除
      deleteClassification() {
        this.ficationLoading = true
        let params = {
          ids: this.delIds
        }
        if (this.platform) {
          params.platform = this.platform
        }
        if (this.shopname) {
          params.shopname = this.shopname
        }
        if (this.noticeuserid) {
          params.noticeuserid = this.noticeuserid
        }
        fetch({
          url: "/hcm/monitorLink/deleteMonitorItemList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.ficationLoading = false
            this.deleteShow = false
            this.$message({
              message: '成功',
              type: 'success'
            });
            this.theQuery();
          } else {
            this.$message.error(res.message);
          }
        })
      },
      // 下载数据
      download() {
        if (this.downData.dataTime === '3' && this.downData.searchformDate.length == 0) {
          this.$message({
            message: '请选择时间',
            type: 'warning'
          });
          return;
        }
        this.downloadLoading = true
        let params = {
          type: this.downData.dataTime,
        };
        if (this.downData.dataTime === '2') {
          this.getRecentDate('',1)
          params.starttime = this.$options.filters['fullTime'] (this.downData.searchformDate[0]).substring(0,10)
          params.endtime = this.$options.filters['fullTime'] (this.downData.searchformDate[1]).substring(0,10)
        }
        if (this.downData.dataTime === '3') {
          params.starttime = this.$options.filters['fullTime'] (this.downData.searchformDate[0]).substring(0,10)
          params.endtime = this.$options.filters['fullTime'] (this.downData.searchformDate[1]).substring(0,10)
        }
        fetch({
          url: "hcm/monitorLink/downloadLinkMonitorList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 5
        }).then(res => {
          //下载
          let that = this
          let data
          if (res.type === 'application/json') {
              let reader = new FileReader();
              reader.readAsText(res, 'utf-8');
              reader.onload = function (e) {
                data = JSON.parse(reader.result)
                console.log(data);
                that.$message({
                  message: data.message,
                  type: 'warning'
                });
                that.downloadLoading = false
                return;
              }
          } else {
            let url = window.URL.createObjectURL(new Blob([res]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", "监控链接.xlsx");
            document.body.appendChild(link);
            link.click();
            this.downloadLoading = false
          }
        });
      },
      notifyPeo() {
        let arrIds = []
        for (let i in this.selectRows) {
          arrIds.push(this.selectRows[i].id)
        }
        if (arrIds.length == 0) {
          this.$message({
            message: '没有选中项',
            type: 'warning'
          });
          return;
        }
        this.notifyDialog = true
      },
      // 确认批量设置通知人
      notifyClick() {
        let arrIds = []
        for (let i in this.selectRows) {
          arrIds.push(this.selectRows[i].id)
        }
        // if (this.notify.length == 0) {
        //   this.$message({
        //     message: '请选择通知人',
        //     type: 'warning'
        //   });
        //   return;
        // }
        console.log(arrIds)
        this.notifyLoading = true
        let params = {
          ids: arrIds.join(','),
          openids: this.notify.join(','),
        }
        if (this.platform) {
          params.platform = this.platform
        }
        if (this.shopname) {
          params.shopname = this.shopname
        }
        if (this.noticeuserid) {
          params.noticeuserid = this.noticeuserid
        }
        fetch({
          url: "/hcm/monitorLink/setPushNoticePeople",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: '成功',
              type: 'success'
            });
            this.notifyLoading = false
            this.notifyDialog = false
            this.theQuery()
            this.getWecharList()
          } else {
            this.$message.error(res.message);
          }
        })
      },
      // 确认推送方式设置
      pushClick() {
        this.pushLoading = true

        let params = {
          noticeway: this.noticeway
        }
        if (this.pushmode == '1') {
          params.pushmode = 'perhour'
        } else {
          params.pushmode = this.noticeType
        }
        fetch({
          url: "/hcm/monitorLink/setPushNoticeType",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: '成功',
              type: 'success'
            });
            this.pushLoading = false
            this.pushDialog = false
            this.theQuery()
            this.getWecharList()
          } else {
            this.$message.error(res.message);
          }
        })
      },
    },
    components: {
      pagination,administrativeNotifier,ShopType
    }
  }
</script>
<style lang="scss">
  #newLinkList{
    .newSku {
      background-color: #e6a23c;
      color: white;
      width: 50px;
      text-align: center;
      border-radius: 16px;
      margin-top: 8px;
      font-size: 12px;
      height: 18px;
      line-height: 18px;
    }
    .el-table__empty-text {
      padding-top: 100px;
      background: url("../../../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }

    .el-table th {
      background-color: #f2f6fe !important;
      color: #4a4b4c;
    }
    .page {
      padding: 20px;
      margin: 10px 0px 0px 0px;
      background-color: white;
    }
    #dialog {
      .el-button--primary {
        color: #FFF;
        background-color: #bda571;
        border-color: #bda571;
      }
      .el-button--primary:hover {
        color: #FFF;
        background-color: #c0ae8a;
        border-color: #c0ae8a;
      }
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    .downBtn {
      display: flex;
      justify-content: flex-start;
    }
    .prompt {
      height: 28px;
      border: 1px solid #108cee;
      background-color: #e6f7ff;
      border-radius: 5px;
      line-height: 28px;
      margin-top: 8px;
      margin-bottom: 8px;

    }
    .promptFont{
      color: #108cee;
      font-size: 14px;
      margin-left: 3px;
      margin-right: 3px;
    }
    .promptFont2{
      color: #108cee;
      font-size: 14px;
      margin-left: 3px;
      margin-right: 3px;
      cursor: pointer;
    }
    .plat-item {
    	display: inline-block;
    	margin-left: 5px;
    	border: 1px solid rgb(164, 163, 163);
    	padding: 2px;
      border-radius: 4px;
    }
  }
  .shopMain {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 5px;
    .content {
      width: calc(100% - 58px);
    }
    img {
      width: 48px;
      height: 48px;
      margin-right: 5px;
      display: block;
    }
  }
  // @import "style/activityDeclaration.scss";
  @import "src/style/tableCommon";
  @import "style/fontSize.scss";
</style>
